import { motion } from "framer-motion";

export const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1.1, delay, ease }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", delay = 0, as: Tag = "h1" }) => (
  <Tag className={className}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className="block"
          initial={{ y: "105%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.3, delay: delay + i * 0.14, ease }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </Tag>
);
